module.exports = __webpack_public_path__ + "img/0910f_cover.0215d448.jpg";